export const STATUS_CHANGE = 'WS_STATUS_CHANGE';
export const RECEIVE_MSG = 'WS_RECEIVE_MSG';
export const EMPTY_MSG_QUEUE = 'WS_EMPTY_MSG_QUEUE';
export const UNREG_COMPONENT = 'WS_UNREG_COMPONENT';